<script>
    import { onMount } from "svelte";
    import BupaPracticeIds from "../../Pages/BupaPracticeIds/BupaPracticeIds.svelte";
    import { checkTokenExpiration } from "../../Utils/utilFunctions.svelte";

    export let params;
    export let tokenRefresh = undefined;

    onMount(async () => {
        tokenRefresh = checkTokenExpiration();
    });
</script>

{#await tokenRefresh then tokenRefreshResult}
    {#if tokenRefreshResult === "valid" || tokenRefreshResult === "refreshed"}
        <div class="flex flex-1 flex-col w-full px-6 py-4 bg-gray-200">
            <BupaPracticeIds {params} />
        </div>
    {/if}
{/await}
